import React from 'react'
import '../../styles.css'

function LevelFeedback(props) {
    if (props.submitState === 0) {
        return (
            <div className='column' style={{textAlign: 'center', marginTop: 50, fontFamily: 'chalkboard', fontSize: 30}}>
                
            </div>
        );
    } else if (props.submitState === 1) {
        if (props.dialogue === 'correct') {
            return (
                <div className='column' style={{textAlign: 'center', marginTop: 40, fontFamily: 'chalkboard', fontSize: 30}}>
                    <b>Correct! Great job!</b>
                </div>
            );
        } else if (props.dialogue === 'incorrect') {
            return (
                <div className='column' style={{textAlign: 'center', marginTop: 40, fontFamily: 'chalkboard', fontSize: 30}}>
                    <b>Incorrect. Don't worry! Please try again :)</b>
                    <b>Correct Letter: {props.letter}</b>
                </div>
            );
        }
    }
}

export default LevelFeedback